import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useState } from "react";
import { handlePostRequest } from "../../services/PostTemplate";
import FileComments from "./FileComments";

function FileCommentsBtn({ fileHeadId = null }) {
    const [commentsModal, setCommentsModal] = useState(false);
    const [commentsData, setCommentsData] = useState([]);
    const [loading, setloading] = useState(false);

    if (fileHeadId == null) {
        return null;
    }

    const getCommentsData = async () => {
        try {
            setloading(true);
            const res = await handlePostRequest({ fileHeadId }, "zbizgateway/authMatrixWorkFlow/getCommentsOnFile");
            setCommentsData(res?.data);
        } catch (err) {
            console.log(err);
        } finally {
            setloading(false);
        }
    };

    const handleComments = async () => {
        await getCommentsData();
        setCommentsModal(true);
    };

    return (
        <>
            <Button onClick={handleComments} className="p-button-rounded p-button-warning p-mr-1" loading={loading} icon={loading ? "pi pi-spin pi-spinner" : "pi pi-comment"}></Button>
            <Dialog visible={commentsModal} header={"Comments"} style={{ width: "80vw" }} onHide={() => setCommentsModal(false)}>
                <FileComments data={commentsData} />
            </Dialog>
        </>
    );
}

export default FileCommentsBtn;
